import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';

const BG = '#05060f';
const BORDER = '#1a2040';
const TEAL = '#2DC896';

const InlineVideo = ({ src }) => {
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef(null);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setPlaying(true);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.96 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      style={{
        position: 'relative',
        width: '100%',
        paddingBottom: '56.25%',
        background: BG,
        border: `1px solid ${BORDER}`,
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: `0 0 40px rgba(45, 200, 150, 0.12), 0 0 80px rgba(45, 200, 150, 0.06)`,
        marginBottom: '3rem',
      }}
    >
      <video
        ref={videoRef}
        src={src}
        controls={playing}
        preload="metadata"
        playsInline
        onEnded={() => setPlaying(false)}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
      />

      {!playing && (
        <button
          onClick={handlePlay}
          aria-label="Play video"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(180deg, rgba(5,6,15,0.25) 0%, rgba(5,6,15,0.55) 100%)',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}
        >
          <span
            style={{
              position: 'relative',
              width: '88px',
              height: '88px',
              borderRadius: '50%',
              background: 'rgba(5, 6, 15, 0.75)',
              border: `2px solid ${TEAL}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(8px)',
              boxShadow: `0 0 30px rgba(45, 200, 150, 0.4)`,
            }}
          >
            <span
              style={{
                position: 'absolute',
                top: '-8px',
                left: '-8px',
                right: '-8px',
                bottom: '-8px',
                borderRadius: '50%',
                border: `2px solid ${TEAL}`,
                opacity: 0.5,
                animation: 'recallcorePulseInline 2s ease-out infinite',
              }}
            />
            <span
              style={{
                width: 0,
                height: 0,
                borderTop: '14px solid transparent',
                borderBottom: '14px solid transparent',
                borderLeft: `22px solid ${TEAL}`,
                marginLeft: '6px',
              }}
            />
          </span>
        </button>
      )}

      <style>{`
        @keyframes recallcorePulseInline {
          0% { transform: scale(1); opacity: 0.5; }
          100% { transform: scale(1.6); opacity: 0; }
        }
      `}</style>
    </motion.div>
  );
};

export default InlineVideo;
